module.exports = __webpack_public_path__ + "img/depa-b.0f57898f.svg";